import type { App } from 'vue'
import { ProcessBase } from '@dustess/ds-cloud'
import { getEnv } from '@utils/env'

export default {
  install(app: App<Element>) {
    // 当前项目中的错误信息，会在页面中展示的，当为空时，就不会展示
    const $env = getEnv()
    const {
      VUE_APP_DUSTESS_CLOUD_TYPE,
    } = $env
    const processBase = new ProcessBase({ type: VUE_APP_DUSTESS_CLOUD_TYPE as any })
    app.config.globalProperties.$ProcessBase = processBase
  },
}
